<div *ngIf="price >= 0" class="flex items-center {{ justifyContentClass }}">
  <!-- <div class="{{styleClass}}">{{ formatPrice(price)}}</div> -->
  <div class="{{ styleClass }}">
    {{
      keepValue
        ? (price | currency : (currency ? currency : currentCurrency))
        : (price | currencyConversion)
    }}
  </div>
</div>
